<template>
  <v-row
    justify="space-between"
    class="component"
  >
    <overlay
      :is-loading="isLoading"
    />

    <v-col
      cols="3"
      align-self="center"
      class="text-center"
    >
      <v-btn
        icon
        variant="text"
        :disabled="previousDisabled"
        @click="previousGameWeek"
      >
        <font-awesome-icon
          :icon="['fas', 'arrow-circle-left']"
          size="2xl"
        />
      </v-btn>
    </v-col>

    <v-col
      v-if="!isLoading"
      cols="6"
      class="text-center"
      :class="{ 'pb-9': !isOpen }"
    >
      <div
        class="text-h4"
      >
        {{ currentGameWeek.title() }}
      </div>
      <div>{{ currentGameWeek.dateRange() }}</div>
      <v-chip
        size="small"
        class="my-2"
      >
        {{ $t(`game_week.${currentGameWeek.status.toLowerCase()}`) }}
      </v-chip>
      <div
        v-if="isOpen"
        class="d-flex flex-row justify-center align-center"
      >
        <font-awesome-icon
          :icon="['fas', 'stopwatch']"
          class="mr-1"
        />
        <count-down
          :duration="remainingTime"
        />
      </div>
    </v-col>

    <v-col
      cols="3"
      align-self="center"
      class="text-center"
    >
      <v-btn
        icon
        variant="text"
        :disabled="nextDisabled"
        @click="nextGameWeek"
      >
        <font-awesome-icon
          :icon="['fas', 'arrow-circle-right']"
          size="2xl"
        />
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
import GameWeekService from '@/services/gameWeek.service';
import CountDown from '@/components/CountDown.vue';
import Overlay from '@/components/Overlay.vue';

export default {
  name: 'GameWeekNavigator',
  components: {
    CountDown,
    Overlay,
  },
  data() {
    return {
      gameWeeks: [],
      index: 0,
      isLoading: true,
    };
  },
  computed: {
    currentGameWeek() {
      return this.gameWeeks[this.index];
    },
    previousDisabled() {
      return this.index === (this.gameWeeks.length - 1);
    },
    nextDisabled() {
      return this.index === 0;
    },
    isOpen() {
      return this.currentGameWeek.isOpen();
    },
    remainingTime() {
      const now = new Date();

      const diffSeconds = Math.floor((this.currentGameWeek.cutOffDate - now) / 1000);

      return diffSeconds > 0 ? diffSeconds : 0;
    },
  },
  watch: {
    index() {
      this.updateGameWeek();
    },
  },
  mounted() {
    GameWeekService.getGameWeeks()
      .then(
        (gameWeeks) => {
          this.gameWeeks = gameWeeks;
          const gameWeekNumber = parseInt(this.$route.query.gameWeek, 10);
          if (gameWeekNumber) {
            const currentGameWeek = this.gameWeeks.find((gameWeek) => gameWeek.number === gameWeekNumber);
            this.index = this.gameWeeks.includes(currentGameWeek) ? this.gameWeeks.indexOf(currentGameWeek) : 0;
          }

          this.updateGameWeek();
          this.isLoading = false;
        },
      );
  },
  methods: {
    updateGameWeek() {
      this.$emit('gameWeekUpdate', this.currentGameWeek);
    },
    previousGameWeek() {
      this.index += 1;
      this.$router.replace({ query: { gameWeek: this.currentGameWeek.number } });
    },
    nextGameWeek() {
      this.index -= 1;
      this.$router.replace({ query: { gameWeek: this.currentGameWeek.number } });
    },
  },
};
</script>
